import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ComingSoonDialogComponent } from '../../../shared/components/coming-soon-dialog/coming-soon-dialog.component';

@Component({
  selector: 'app-bond-originator',
  templateUrl: './bond-originator.component.html',
  styleUrls: ['./bond-originator.component.scss']
})
export class BondOriginatorComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    this.openDialog();
  }

  openDialog(): void {
    this.dialog.open(ComingSoonDialogComponent, {
      width: '35vw',
      height: '35vh'
    });
  }
}
